export default __webpack_public_path__ + "static/media/blue-background.2e41a87e.svg";